import { Component } from 'react'
import { withTheme } from 'styled-components'

interface WithFlexProps {
  computedWeight?: number
  theme?: {
    containerSizes?: object
  }
  width?: number | string
}

export default function withFlex(WrappedComponent: any) {
  class WithFlex extends Component<WithFlexProps> {
    static displayName = `WithFlex(${getDisplayName(WrappedComponent)})`

    styles: any

    constructor(props: any) {
      super(props)

      this.computedStyles = this.computedStyles.bind(this)

      this.styles = {
        minWidth: 0
      }
    }

    computedStyles() {
      const { width, theme, computedWeight } = this.props
      const styles = {}

      if (typeof width === 'number') {
        // @ts-expect-error
        styles.flexGrow = 1
        // @ts-expect-error
        styles.flexShrink = 1
        // @ts-expect-error
        styles.flexBasis = `${computedWeight || width}%`
      } else if (width === 'auto') {
        // @ts-expect-error
        styles.flexGrow = 0
        // @ts-expect-error
        styles.flexShrink = 1
        // @ts-expect-error
        styles.flexBasis = 'auto'
      } else if (typeof width === 'string' && /px$/i.test(width)) {
        // Set it to a specific pixel width!  Native there's no 'px' but you can provide a number
        // @ts-expect-error
        styles.flexGrow = 0
        // @ts-expect-error
        styles.flexShrink = 0
        // @ts-expect-error
        styles.flexBasis = width
        // @ts-expect-error
      } else if (theme.containerSizes[width]) {
        // You can also use the container sizes property in theme.theme
        // @ts-expect-error
        styles.flexGrow = 0
        // @ts-expect-error
        styles.flexShrink = 0
        // @ts-expect-error
        styles.flexBasis = theme.containerSizes[width]
      } else {
        // @ts-expect-error
        styles.flexGrow = 1
        // @ts-expect-error
        styles.flexShrink = 1
        // @ts-expect-error
        styles.flexBasis = `${computedWeight || 'auto'}%`
      }

      return styles
    }

    render() {
      return (
        <div style={{ ...this.styles, ...this.computedStyles() }} data-item="wg-flex">
          <WrappedComponent {...this.props} />
        </div>
      )
    }
  }

  return withTheme(WithFlex)
}

function getDisplayName(WrappedComponent: any) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}
